module.exports = __webpack_public_path__ + "static/media/image-3.b2ac302f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WebsiteVsSocialMediaPages/image-3.jpg
// module id = 420
// module chunks = 0